module.exports = __webpack_public_path__ + "img/fabio.f91e82b9.webp";